import { HELP_MS_URL, X_API_KEY } from "../config/urlconfig"
import axios from "axios"

const customHeader = () => ({
    "Content-Type": "application/json",
    "x-api-key": X_API_KEY,
    Accept: "application/json",
    Authorization: "Bearer " + localStorage.getItem('token'),
})

const axiosRequest = async (options) => {
  try {
    return await axios(options)
  } catch (err) {
    if (err.response) {
      const responseError = new Error(`${err.response.data?.error?.message}` || "Request Failed")
      responseError.code = err.response.status
      responseError.response = err.response.data
      throw responseError
    }
    throw err
  }
}

const axiosUtil = {
    get: async (path, params, headers) => {
        try {
            const options = {
                method: 'get',
                url: `${HELP_MS_URL}${path}`,
                headers: {...customHeader(), ...headers},
                params: params || null
            }
          
            return await axiosRequest(options) 
        } catch (err) {
            throw err
        }
    },
    post: async (path, data, headers, params) => {
        try {
            const options = {
                method: 'post',
                url: `${HELP_MS_URL}${path}`,
                headers: { ...customHeader(), ...headers },
                data: data || null,
                params: params || null
            }
          
            return await axiosRequest(options)
        } catch (err) {
            throw err
        }
    },
    put: async (path, data, headers, params) => {
        try {
            const options = {
                method: 'put',
                url: `${HELP_MS_URL}${path}`,
                headers: { ...customHeader(), ...headers },
                data: data || null,
                params: params || null
            }
          
            return await axiosRequest(options)
        } catch (err) {
            throw err
        }
    },
}

export default  axiosUtil